/**
 * フェイクテーブルライン用の銀行ボタンコンポーネント
 * @param onChange - 値が変更されたときのコールバック関数
 * @param onSuccessfulWithBank - 銀行が選択されたときのコールバック関数
 * @param error - エラーの有無
 * @param errorMessage - エラーメッセージ
 * @param bankSelButtonName - 銀行選択ボタンの表示名
 */
import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import TkButton from "../../../TkButton";
import { IBankButtonForFakeTableLineProps } from "../../../../../type/componentsType/TkBankSelection";
import TkBankSelection from "../../../../molecules/TkBankSelection";
import { Typography } from "@mui/material";
import "./_style.scss";
import TkCheckbox from "../../../TkCheckbox";

const BankButtonForFakeTableLine: React.FC<IBankButtonForFakeTableLineProps> = (
  props
) => {
  const {
    onChange,
    onSuccessfulWithBank,
    error,
    errorMessage,
    bankSelButtonName = "振込先金融機関登録",
    isDaikou = false,
    onGoToKaiGai,
    wantToSetValue,
    checkKaigai,
    ...rest
  } = props;

  const [open, setOpen] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  useEffect(() => {
    if (wantToSetValue) {
      onChange && onChange({ target: { value: wantToSetValue } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantToSetValue]);

  useEffect(() => {
    if (checkKaigai) {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  }, [checkKaigai]);

  const handleSuccessful = (data: any) => {
    onSuccessfulWithBank && onSuccessfulWithBank(data);
    onChange && onChange({ target: { value: data } });
    setOpen(false);
  };

  return (
    <Box className="bankButtonForFakeTableLine">
      <Box>
        <TkButton
          color={error ? "error" : "primary"}
          onClick={() => setOpen(true)}
          disabled={rest.buttonDisabled || buttonDisabled}
        >
          {bankSelButtonName}
        </TkButton>

        <Typography className="errorText" color="error">
          {!checkKaigai && errorMessage}
        </Typography>
      </Box>

      <Box className="checkboxInTableLine">
        {isDaikou && (
          <TkCheckbox
            checked={checkKaigai}
            onChange={() => {
              onGoToKaiGai && onGoToKaiGai(!checkKaigai);
            }}
            label="海外送金"
          />
        )}
      </Box>

      <TkBankSelection
        open={open}
        onSuccessful={handleSuccessful}
        onClose={() => setOpen(false)}
      ></TkBankSelection>
    </Box>
  );
};

export default BankButtonForFakeTableLine;
